const HOME_PATH = 'https://cms.avidid.com/api'
const PRODUCT_LINES_PATH = 'https://cms.avidid.com/api/productlines'
const PRODUCTS_PATH = 'https://cms.avidid.com/api/products'

export async function getProductContent(query, page, isTitle = true,) {
  const queryPath = `${PRODUCTS_PATH}?where[${isTitle ? 'title' : 'productid'}][equals]=${query}${page ? `&page=${page}` : ''}`;

  const requestOptions = {
    method: 'GET',
    headers: { accept: 'application/json' },
  };

  return window.fetch(queryPath, requestOptions)
    .then(response => {
      if (response.ok) return (response.json());
      else {
        throw (response);
      }
    })
    .then(data => {
      return { status: 200, data: data };
    })
    .catch(error => {
      if (error && error.name === 'AbortError') {
        return { status: error.name, data: error };
      }
      return { status: error.status, data: error.statusText };
    });
}

export async function getProductsList(query, page) {
  const queryPath = `${PRODUCTS_PATH}?where[productline.title][equals]=${query}${page ? `&page=${page}` : ''}`;

  const requestOptions = {
    method: 'GET',
    headers: { accept: 'application/json' },
  };

  return window.fetch(queryPath, requestOptions)
    .then(response => {
      if (response.ok) return (response.json());
      else {
        throw (response);
      }
    })
    .then(data => {
      return { status: 200, data: data };
    })
    .catch(error => {
      if (error && error.name === 'AbortError') {
        return { status: error.name, data: error };
      }
      return { status: error.status, data: error.statusText };
    });
}

export async function getProductLines(query, page) {
  const queryPath = `${PRODUCT_LINES_PATH}?where[productcategory.title][equals]=${query}${page ? `&page=${page}` : ''}`;

  const requestOptions = {
    method: 'GET',
    headers: { accept: 'application/json' },
  };

  return window.fetch(queryPath, requestOptions)
    .then(response => {
      if (response.ok) return (response.json());
      else {
        throw (response);
      }
    })
    .then(data => {
      return { status: 200, data: data };
    })
    .catch(error => {
      if (error && error.name === 'AbortError') {
        return { status: error.name, data: error };
      }
      return { status: error.status, data: error.statusText };
    });
}

export async function getProductCategories(page) {
  const queryPath = `${HOME_PATH}/productcategories${page ? `&page=${page}` : ''}`;
  `s`
  const requestOptions = {
    method: 'GET',
    headers: { accept: 'application/json' },
  };

  return window.fetch(queryPath, requestOptions)
    .then(response => {
      if (response.ok) return (response.json());
      else {
        throw (response);
      }
    })
    .then(data => {
      return { status: 200, data: data };
    })
    .catch(error => {
      if (error && error.name === 'AbortError') {
        return { status: error.name, data: error };
      }
      return { status: error.status, data: error.statusText };
    });
}

export async function searchProduct(query, signal, isTitle = true, page = 0) {
  const queryPath = `${PRODUCTS_PATH}?where[${isTitle ? 'title' : 'productid'}][like]=${query}${page ? `&page=${page}` : ''}`;

  const requestOptions = {
    method: 'GET',
    headers: { accept: 'application/json' },
    signal: signal
  };

  return window.fetch(queryPath, requestOptions)
    .then(response => {
      if (response.ok) return (response.json());
      else {
        throw (response);
      }
    })
    .then(data => {
      return { status: 200, data: data };
    })
    .catch(error => {
      if (error && error.name === 'AbortError') {
        return { status: error.name, data: error };
      }
      return { status: error.status, data: error.statusText };
    });
}